import * as S from './style';

export default function LinkButtonComponent ({ children, ...props }) {
  return (
      <S.LinkButton {...props} className="button secondary">{children}</S.LinkButton>
  );
}
